import {Base} from './base.model';

export abstract class Period extends Base {

  constructor(protected id: number, public inizioValidita, public fineValidita) {
    super(id);
    this.inizioValidita = inizioValidita ? new Date(inizioValidita) : null;
    this.fineValidita = fineValidita ? new Date(fineValidita) : null;
  }

  /**
   * FIXME: l'assegnamento nel costruttore non ha esito. Usare il getter.
   * @returns {Date}
   */
  getInizio() {
    if (this.inizioValidita) {
      const date = new Date(this.inizioValidita);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    return null;
  }

  getFine() {
    if (this.fineValidita) {
      const date = new Date(this.fineValidita);
      date.setHours(0, 0, 0, 0);
      return date;
    }
  }

  belongToPeriod(date: Date): boolean {
    date.setHours(0, 0, 0, 0);
    return this.fromIsActive(date) && this.toIsActive(date);
  }

  private fromIsActive(date) {
    return !this.getInizio() || (!date || this.getInizio() <= date);
  }

  private toIsActive(date) {
    return !this.getFine() || (!date || this.getFine() >= date);
  }

  periodBelongToPeriod(from, to) {
    from.setHours(0, 0, 0, 0);
    to.setHours(0, 0, 0, 0);
    return this.belongToPeriod(from) && this.belongToPeriod(to);
  }


}
